import { useTranslation } from 'react-i18next'
import { CategoryArchive } from '@/components/sections'
import type { Line } from '@/data/products'

const lineOrder: Line[] = ['fragrance']

export function CategoryFragranzePage() {
  const { t } = useTranslation('common')
  return (
    <CategoryArchive
      category="fragranze"
      lineOrder={lineOrder}
      hero={{
        eyebrow: t('categoryFragranze.hero.eyebrow'),
        title: t('categoryFragranze.hero.title'),
        titleItalic: t('categoryFragranze.hero.titleItalic'),
        intro: t('categoryFragranze.hero.intro'),
        image: '/images/categories/fragranze-hero.jpg',
        imageAlt: t('categoryFragranze.hero.imageAlt'),
      }}
      faq={{
        eyebrow: t('categoryFragranze.faq.eyebrow'),
        title: t('categoryFragranze.faq.title'),
        titleItalic: t('categoryFragranze.faq.titleItalic'),
        body: (
          <>
            <p>{t('categoryFragranze.faq.bodyParagraph1')}</p>
            <p>
              <strong className="text-bruno">{t('categoryFragranze.faq.bodyQuestion')}</strong>{' '}
              {t('categoryFragranze.faq.bodyParagraph2')}
            </p>
          </>
        ),
      }}
      labels={{
        filterByLine: t('categoryFragranze.archiveLabels.filterByLine'),
        scrollLeft: t('categoryFragranze.archiveLabels.scrollLeft'),
        scrollRight: t('categoryFragranze.archiveLabels.scrollRight'),
        all: t('categoryFragranze.archiveLabels.all'),
        linePrefix: t('categoryFragranze.archiveLabels.linePrefix'),
        productsSuffix: t('categoryFragranze.archiveLabels.productsSuffix'),
        defaultEyebrow: t('categoryFragranze.archiveLabels.defaultEyebrow'),
        defaultFaqEyebrow: t('categoryFragranze.archiveLabels.defaultFaqEyebrow'),
        categoryAriaLabel: t('categoryFragranze.hero.ariaLabel'),
      }}
    />
  )
}
